export default __webpack_public_path__ + "static/media/sesame_seed2.726eba73.png";